<nz-table
  #basicTable
  [nzData]="items"
  [nzLoading]="isLoading"
  [nzFrontPagination]="false"
  nzSize="small"
  >
  <thead>
    <tr>
      <th>Name</th>
      <th>Bestellnummer</th>
      <th>Umsatz</th>
    </tr>
  </thead>
  <tbody>
    @for (item of basicTable.data; track item) {
      <tr>
        <td>{{ item.articleTitle }}</td>
        <td>{{ item.number }}</td>
        <td class="white-space-no-wrap">{{ item.amount | numberToCurrency }}</td>
      </tr>
    }
  </tbody>
</nz-table>
